/** @jsx builderX.jsx */
import { builderX, Sprite, Image } from '@gongxigames/framework/core/fragments/BuilderX';

export default <Sprite name='ImagesForAdvancedText'>
    <Image scale={[0.3, 0.3]} name='obscure' src='a_dimmed_x3'/>
    <Image scale={[0.3, 0.3]} name='wild' src='j_double_x3'/>
    <Image name='scatter_red' src='scatter_red'/>
</Sprite>;
